export class DimensionsModel {
    height: number;
    width: number;

    constructor(
        height: number,
        width: number
    ) {
        this.height = height;
        this.width = width;
    }
}
